<script lang="ts">
  import { appStore } from "$app/store.svelte"
  interface Props {
    onUpdateStep: (step: string) => void
    step: string
  }

  let { onUpdateStep, step }: Props = $props()

  let steps = $state([])

  if (appStore.current_user.role === "recognition") {
    steps = [
      {
        id: "welcome",
        title: "Welcome"
      },
      {
        id: "your_profile",
        title: "Profile"
      },
      {
        id: "one_page_view",
        title: "OPV"
      },
      {
        id: "recognitions",
        title: "Recognitions"
      },
      {
        id: "mobile_app",
        title: "App"
      }
    ]
  } else {
    steps = [
      {
        id: "welcome",
        title: "Welcome"
      },
      {
        id: "your_profile",
        title: "Profile"
      },
      {
        id: "one_page_view",
        title: "OPV"
      },
      {
        id: "activity",
        title: "Activity"
      },
      {
        id: "recognitions",
        title: "Recognitions"
      },
      {
        id: "mobile_app",
        title: "App"
      },
      {
        id: "resources",
        title: "Resources"
      }
    ]
  }

  let step_count = () => {
    return steps.findIndex((s) => {
      return s.id === step
    })
  }

  function updateStep(step) {
    onUpdateStep(step)
  }
</script>

<nav class="flex z-20" aria-label="Breadcrumb">
  <ol class="flex items-center space-x-0.5 md:space-x-2 flex-wrap">
    {#each steps as { id, title }, index}
      <li>
        <div
          class={index <= step_count()
            ? "flex items-center text-white font-bold"
            : "flex items-center text-gray-400"}
        >
          {#if index > 0}
            <svg
              class="flex-shrink-0 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          {/if}
          {#if index <= step_count()}
            <button
              onclick={() => updateStep(id)}
              class:ml-1={index > 0}
              class:text-green-200={index == step_count()}
              class="text-xs leading-tight md:leading-normal md:text-sm font-medium whitespace-nowrap"
            >
              {title}
            </button>
          {:else}
            <span
              class:ml-1={index > 0}
              class="text-xs leading-tight md:leading-normal md:text-sm font-medium whitespace-nowrap"
            >
              {title}
            </span>
          {/if}
        </div>
      </li>
    {/each}
  </ol>
</nav>
